import React from 'react'; 
import PropTypes from 'prop-types';

const ControlHeader = ({title, subTitle, required}) => {
  return (
    <div>
    <label className={required ? 'label-required' : ''}>{title}</label>
    {
      subTitle ?     
      <div>
       { subTitle}
      </div>
      :
      null 
    }
    </div>
  );
};

ControlHeader.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool
};
export default ControlHeader;